// TPM = TELEMETRY_POWER_MONITORING
export const SET_TPM_LOADED_CHARGERS = 'SET_TPM_LOADED_CHARGERS';
export const SET_TPM_SELECTED_CHARGERS = 'SET_TPM_SELECTED_CHARGERS';
export const SET_TPM_CHARGER_METRICS = 'SET_TPM_CHARGER_METRICS';
export const MERGE_TPM_CHARGER_METRICS = 'MERGE_TPM_CHARGER_METRICS';
export const SET_TPM_TIME_OFFSET_TYPE = 'SET_TPM_TIME_OFFSET_TYPE';
export const SET_TPM_SHOW_RETRY_ICON_ON_SELECTED_CHARGERS = 'SET_TPM_SHOW_RETRY_ICON_ON_SELECTED_CHARGERS';

export const setPowerMonitoringLoadedChargers = (chargers) => ({
  type: SET_TPM_LOADED_CHARGERS,
  payload: chargers,
});

export const setPowerMonitoringSelectedChargers = (chargers) => ({
  type: SET_TPM_SELECTED_CHARGERS,
  payload: chargers,
});

export const setPowerMonitoringChargerMetrics = (metrics) => ({
  type: SET_TPM_CHARGER_METRICS,
  payload: metrics,
});

export const mergePowerMonitoringChargerMetrics = (metrics) => ({
  type: MERGE_TPM_CHARGER_METRICS,
  payload: metrics,
});

export const setPowerMonitoringTimeOffsetType = (offset) => ({
  type: SET_TPM_TIME_OFFSET_TYPE,
  payload: offset,
});

export const setShowRetryIconOnSelectedChargers = (chargerIds = [], value) => ({
  type: SET_TPM_SHOW_RETRY_ICON_ON_SELECTED_CHARGERS,
  payload: { chargerIds, value },
});
